export default __webpack_public_path__ + "static/media/baseball.5aef3849.jpg";